import React, { useState, useEffect } from "react";
import Arrow, { wfStates } from "./Arrow";
import StatusBox, {
  statusBoxWidth,
  offSetFromArtifact,
  totalStatusBoxLength,
} from "./StatusBox";
import WorkflowSummary, {
  workflowSummaryHeight,
  workflowSummaryWidth,
} from "./WorkflowSummary";
import { useSelector } from "react-redux";
import { selectConnectionWorkflows } from "@/features/homepage/homeSlice";
import {
  selectIsWorkflowStepsOpen,
  selectLifecyclePopupOpen,
  selectLifecycleDetails,
} from "@/features/homepage/workflowManagerSlice";

const arrowDecorationPositionHelper = (
  startX,
  startY,
  endX,
  endY,
  direction,
  statusBoxAlignment,
  componentWidth,
  componentHeight,
  totalComponentHeight
) => {
  const initialXPosition = statusBoxAlignment === "start" ? startX : endX;
  const initialYPosition = statusBoxAlignment === "start" ? startY : endY;
  const x =
    direction === "horizontal"
      ? initialXPosition + offSetFromArtifact
      : initialXPosition - componentWidth / 2;
  const y =
    direction === "horizontal"
      ? initialYPosition - componentHeight / 2
      : initialYPosition - totalComponentHeight + (statusBoxAlignment === "start" ? totalStatusBoxLength : 0);
  return { x, y };
};

const ArtifactMapWorkflow = ({
  source,
  target,
  startX,
  startY,
  endX,
  endY,
  onClick,
  turns,
  selectedWorkflow,
  notTrueWorkflow,
  statusBoxAlignment,
  direction,
  workflows,
  operationId,
  onInteraction,
}) => {
  const [workflowSummaryStatus, setWorkflowSummaryStatus] =
    useState("completed");
  const [workflowState, setWorkflowState] = useState(wfStates.default);

  const workflowPopupOpen = useSelector(selectIsWorkflowStepsOpen);
  const connectionWorkflows = useSelector(selectConnectionWorkflows);

  const lifecyclePopupOpen = useSelector(selectLifecyclePopupOpen);
  const workflowsForLifecycle = useSelector(selectLifecycleDetails);

  var selectedWorkflowsInfo = [];
  if (
    workflowsForLifecycle &&
    workflowsForLifecycle.workflowsCompleted &&
    workflowsForLifecycle.workflowsUpcoming
  ) {
    selectedWorkflowsInfo = [
      ...workflowsForLifecycle.workflowsCompleted.map((workflow) => ({
        operationId: workflow.operationId,
        status: workflow.status,
      })),
      ...workflowsForLifecycle.workflowsUpcoming.map((workflow) => ({
        operationId: workflow.operationId,
        status: workflow.status,
      })),
    ];
  }

  useEffect(() => {
    handleWorkflowInteraction();
  }, [
    selectedWorkflow,
    operationId,
    workflowState,
    workflowPopupOpen,
    connectionWorkflows,
    lifecyclePopupOpen,
  ]);

  const handleWorkflowInteraction = () => {
    if (lifecyclePopupOpen === true && selectedWorkflowsInfo.length !== 0) {
      const selectedWorkflow = selectedWorkflowsInfo.find(
        (workflow) => workflow.operationId === operationId
      );
      if (selectedWorkflow) {
        setWorkflowSummaryStatus(selectedWorkflow.status);
        setWorkflowState(wfStates.popupSelected);
      }
    } else {
      if (selectedWorkflow === operationId && workflowPopupOpen) {
        setWorkflowState(wfStates.popupSelected);
      } else if (selectedWorkflow === operationId) {
        setWorkflowState(wfStates.selected);
      } else if (!connectionWorkflows.includes(operationId)) {
        setWorkflowState(wfStates.disabled);
      } else if (selectedWorkflow === 0) {
        setWorkflowState(wfStates.default);
      } else {
        setWorkflowState(wfStates.lowlighted);
      }
    }
    onInteraction(source, target, operationId, workflowState);
  };

  const statusBoxPosition = arrowDecorationPositionHelper(
    startX,
    startY,
    endX,
    endY,
    direction,
    statusBoxAlignment,
    statusBoxWidth,
    statusBoxWidth,
    totalStatusBoxLength
  );
  const workflowSummaryPosition = arrowDecorationPositionHelper(
    startX,
    startY,
    endX,
    endY,
    direction,
    statusBoxAlignment,
    workflowSummaryWidth,
    workflowSummaryHeight,
    totalStatusBoxLength
  );

  return (
    <>
      <Arrow
        operationId={operationId}
        source={source}
        target={target}
        startX={startX}
        startY={startY}
        endX={endX}
        endY={endY}
        turns={turns}
        notTrueWorkflow={notTrueWorkflow}
        workflowState={workflowState}
        setWorkflowState={setWorkflowState}
        workflowSummaryStatus={workflowSummaryStatus}
        direction={direction}
      />

      {!notTrueWorkflow && (
        <StatusBox
          statuses={[
            {
              status: "Successful",
              count: (workflows?.Successful || 0) + (workflows?.CompletedWithWarning || 0),
            },
            {
              status: "Processing",
              count: workflows?.Processing || 0,
            },
            {
              status: "Error",
              count: workflows?.Error || 0,
            },
            {
              status: "Not Queued",
              count: workflows?.NotQueued || 0,
            },
          ]}
          x={statusBoxPosition.x}
          y={statusBoxPosition.y}
          workflowState={workflowState}
          direction={direction}
        />
      )}
    </>
  );
};

export default ArtifactMapWorkflow;
